import React from 'react';
import Chart from 'react-apexcharts';
import { processChartData } from '../../hooks/useCombinedAnalytics';

const TrafficChart = ({ connections, timeRange, clientStatsActive }) => {
  const chartData = processChartData(connections, timeRange, clientStatsActive);

  if (!chartData || !chartData.categories || chartData.categories.length === 0) {
    return (
      <div className="flex items-center justify-center h-80 text-gray-500 dark:text-dark-500">
        Нет данных для графика
      </div>
    );
  }

  return (
    <Chart
      options={{
        chart: {
          height: 350,
          type: 'area',
          toolbar: {
            show: false
          },
          background: 'transparent'
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth',
          width: 2
        },
        colors: ['#3b82f6', '#10b981', '#f59e0b'],
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.4,
            opacityTo: 0.1,
            stops: [0, 90, 100]
          }
        },
        xaxis: {
          type: 'datetime',
          categories: chartData.categories,
          labels: {
            style: {
              colors: '#9ca3af'
            },
            datetimeFormatter: {
              year: 'yyyy',
              month: "dd MMM",
              day: 'dd MMM',
              hour: 'HH:mm'
            }
          }
        },
        yaxis: {
          labels: {
            style: {
              colors: '#9ca3af'
            }
          }
        },
        tooltip: {
          x: {
            format: 'dd/MM/yy HH:mm'
          },
          theme: 'dark'
        },
        legend: {
          labels: {
            colors: '#9ca3af'
          }
        },
        grid: {
          borderColor: '#374151',
          strokeDashArray: 4
        }
      }}
      series={[
        {
          name: 'Входящий (KB)',
          data: chartData.inData
        },
        {
          name: 'Исходящий (KB)',
          data: chartData.outData
        },
        {
          name: 'Активных',
          data: chartData.activeData
        }
      ]}
      type="area"
      height={350}
    />
  );
};

export default TrafficChart;
